<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png" />
  <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {

  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
</style>
